module.exports = "<h1 class=\"header\">\n  Bijlagen\n</h1>\n<div class=\"content\">\n<p>\n  bijlagen works!\n</p>\n</div>\n"